<template>
    <v-container style="margin: 60px 10%">
      <vueHeadful
      :title="this.$i18n.t('Menu.Perfil') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
      <v-row>
        <v-col cols="12" align="center" style="margin-top:3%;">
          <v-btn :to="$t('Alias.GeneralPerfil')" text class="mx-3">{{ $t('Menu.GeneralPerfil') }}</v-btn>
          <v-btn :to="$t('Alias.FavoritosPerfil')" text class="mx-3">{{ $t('Menu.FavoritosPerfil') }}</v-btn>
          <v-btn :to="$t('Alias.PedidosPerfil')" text class="mx-3">{{ $t('Menu.PedidosPerfil') }}</v-btn>
        </v-col>
        <v-col cols="12">
          <router-view />
        </v-col>
      </v-row>
    </v-container>
</template>

<script>

export default {
  name: 'Perfil'
}
</script>
